// extracted by mini-css-extract-plugin
module.exports = {"button":"SectionFileUpload_button__CSjs6","spinner":"SectionFileUpload_spinner__2tGNW","spin":"SectionFileUpload_spin__3EurB"};